import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { StructureService } from '@app/shared/structure/structure.service';
import { of } from 'rxjs';

export const structureRouteResolver: ResolveFn<unknown> = (route: ActivatedRouteSnapshot) => {
    const structureService = inject(StructureService);
    const structure = route.params['structure'];
    structureService.current$.next(structure);
    return of(structure);
};
